import React from "react";
import {
  buttonStyle,
  dangerButtonStyle,
  SectionCard,
} from "../patientChartShared";

export default function DocumentsSection({
  selectedEncounterId,
  documents = [],
  uploading,
  handleUploadDocument,
  handleDeleteDocument,
  setScanModalOpen,
  expandedSections,
  toggleSection,
  sectionRef,
  activeSection,
  readOnlyMode = false,
}) {
  const uploadDisabled = uploading || readOnlyMode;

  return (
    <SectionCard
      title="Documents / 12-Lead ECG"
      sectionKey="documents"
      expandedSections={expandedSections}
      toggleSection={toggleSection}
      sectionRef={sectionRef}
      activeSection={activeSection}
      extraHeaderContent={
        selectedEncounterId ? (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <label
              style={{
                ...buttonStyle,
                opacity: uploadDisabled ? 0.6 : 1,
                cursor: uploadDisabled ? "not-allowed" : "pointer",
              }}
            >
              {uploading ? "Uploading..." : "Upload PDF / Photo"}
              <input
                type="file"
                accept="application/pdf,image/*"
                capture="environment"
                style={{ display: "none" }}
                onChange={handleUploadDocument}
                disabled={uploadDisabled}
              />
            </label>

            <button
              type="button"
              style={buttonStyle}
              onClick={() => {
                if (readOnlyMode) return;
                setScanModalOpen(true);
              }}
              disabled={uploadDisabled}
            >
              Scan Document
            </button>
          </div>
        ) : null
      }
    >
      {!selectedEncounterId ? (
        <div style={{ color: "#64748b" }}>
          Create or select an encounter first.
        </div>
      ) : !documents.length ? (
        <div style={{ color: "#64748b" }}>No documents uploaded.</div>
      ) : (
        <div style={{ display: "grid", gap: 8 }}>
          {documents.map((docItem, i) => (
            <div
              key={`${docItem.path || docItem.url || docItem.name || "doc"}-${i}`}
              style={{
                border: "1px solid #fde68a",
                borderRadius: 10,
                padding: 9,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
                background: "#fffef8",
              }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>
                  {docItem.name}
                </div>
                <div style={{ fontSize: 11, color: "#64748b" }}>
                  {docItem.uploadedAt || "—"}
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <a
                  href={docItem.url}
                  target="_blank"
                  rel="noreferrer"
                  style={buttonStyle}
                >
                  View
                </a>

                <button
                  type="button"
                  style={dangerButtonStyle}
                  onClick={() => {
                    if (readOnlyMode) return;
                    handleDeleteDocument(docItem, i);
                  }}
                  disabled={readOnlyMode}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
}